
import { v4 as uuid } from 'uuid';
import Vue from "vue";

import {Question} from "@/api/types/Question";
import {Form} from "@/api/types/Form";
import {Tenant} from "@/api/types/Tenant";
import QuestionBuilder from "@/components/form/QuestionBuilder.vue";
import ScoreRulesBuilder from "@/components/form/rules/score_rules/ScoreRulesBuilder.vue";
import {ScoreRule} from "@/api/types/ScoreRule";

export default Vue.extend({
  components: {
    ScoreRulesBuilder,
    QuestionBuilder
  },
  name: "FormBuilder",
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {
        return {
          title: "",
          description: "",
          photoUrl: "",
          questions: [
            {
              title: "",
              type: "text-field",
              required: false,
              options: [""],
              linearScale: {
                minValue: 0,
                maxValue: 1,
                minLabel: "",
                maxLabel: "",
              },
              image: {
                file: null,
                deleting: false,
                deleteUrl: null
              }
            },
          ] as Partial<Question>[],
          score: false as boolean,
          tenantIds: [] as string[]
        } as Partial<Form>
      }
    }
  },
  data() {
    return {
      editedForm: this.value,
      tenants: [] as Tenant[],
      rulesCopy: [] as Partial<ScoreRule>[]
    };
  },
  methods: {
    addNewQuestion(): void {
      this.$emit("add");
      this.editedForm.questions?.push({
        keyId: uuid(),
        title: "",
        type: "text-field",
        required: false,
        options: [''],
        linearScale: {
          minValue: 0,
          maxValue: 1,
          minLabel: "",
          maxLabel: "",
        },
        imageUrl: null,
        image: {
          file: null,
          deleting: false,
          deleteUrl: null
        },
        scoreList: [],
        position: this.totalQuestions
      });
    },
    copyQuestion(): void {
      this.$emit("add");
    },
    emitClear() {
      this.$emit("clear");
    },
    dragged(item: Question) {
      console.log(item);
    },
    toggleRules() {
      if (!this.editedForm.scoreRulesStatus && !this.rulesCopy.length) {
        this.rulesCopy = this.editedForm.scoreRules;
        this.editedForm.scoreRules = [];
      }
      else {
        this.editedForm.scoreRules = this.rulesCopy;
        this.rulesCopy = [];
      }
    }
  },
  computed: {
    totalQuestions() {
      return this.value?.questions.length;
    }
  },
  watch: {
    editedForm: function (form) {
      this.editedForm = form;
      this.$emit("input", form);
    },
    value: function (value) {
      this.editedForm = value;
    },
  },
});
